import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ButtonLink from '../../Buttons/ButtonLink'

interface FaqItem {
  question: string
  answer: string
}

const faqItemsData: FaqItem[] = [
  {
    question: 'Czy współpraca wymaga podpisania umowy?',
    answer: 'Nie, po wyborze pakietu zostanie przesłany do Państwa regulamin do akceptacji, którr reguluje zasady publikacji i zapewnia przejrzystość warunków. Cały proces może być zrealizowany elektronicznie.'
  },
  {
    question: 'Nie mam zespołu do obsługi platformy – co wtedy?',
    answer: 'Nie musisz mieć! Oferujemy pełną opiekę w ramach pakietów: od wprowadzenia danych, wgrywanie modeli, zdjęć oraz artkułów. Twój dedykowany opiekun zadba o to, by Twoje produkty/usługi były widoczne i zachęcały projektantów do pobrania.'
  },
  {
    question: 'Od czego zależy pozycjonowanie moich produktów na waszej platformie?',
    answer: 'Na widoczność produktów wpływa m.in. jakość wprowadzonych danych, kompletność profilu, zaangażowanie użytkowników oraz wybrany pakiet. Im wyższy pakiet – tym większa ekspozycja, lepsze miejsce w wynikach wyszukiwania.'
  },
  {
    question: 'Czy mogę promować swoją usługę (np. stolarstwo, projektowanie oświetlenia) tak samo jak produkt?',
    answer: 'Oczywiście. Usługodawcy również mają możliwość prezentacji swojego portfolio, zakresu usług oraz lokalizacji działania. Projektanci często szukają właśnie konkretnych wykonawców.'
  },
  {
    question: 'Jak działa system powiadomień i statystyk?',
    answer: 'Na e-mail otrzymasz dane dotyczące wyświetleń, pobrań i zainteresowania Twoimi produktami/usługami. W pakietach wyższych możesz też otrzymywać raporty cykliczne'
  },
  {
    question: 'Czy mogę targetować swoje produkty na konkretny region lub kraj?',
    answer: 'Tak. Możesz określić obszar działania (np. tylko Polska, tylko Niemcy lub cała Europa), co pozwala projektantom znaleźć dostawców lokalnych.'
  },
  {
    question: 'Czy mogę przedłużyć pakiet lub przejść na wyższy?',
    answer: 'Tak. W każdej chwili możesz uaktualnić swój pakiet, a różnicę cenową zapłacisz proporcjonalnie.'
  },
  {
    question: 'Czy możliwa jest integracja z moim sklepem internetowym?',
    answer: 'Nie, przy każdym produkcie będzie znajdował się link przekierowujący do Twojego produktu na sklepie.'
  }
]

const PlusIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={2.5} stroke='currentColor' className='tw-w-5 tw-h-5 tw-text-teal'>
    <path strokeLinecap='round' strokeLinejoin='round' d='M12 4.5v15m7.5-7.5h-15' />
  </svg>
)

const MinusIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={2.5} stroke='currentColor' className='tw-w-5 tw-h-5 tw-text-green'>
    <path strokeLinecap='round' strokeLinejoin='round' d='M19.5 12h-15' />
  </svg>
)

function FAQ () {
  const navigate = useNavigate()
  const [openFaq, setOpenFaq] = useState<number | null>(0)

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index)
  }

  const halfIndex = Math.ceil(faqItemsData.length / 2)
  const firstHalf = faqItemsData.slice(0, halfIndex)
  const secondHalf = faqItemsData.slice(halfIndex)

  const renderFaqItem = (item: FaqItem, globalIndex: number, isFirstInColumn: boolean) => {
    const isOpen = openFaq === globalIndex
    return (
      <div
        key={globalIndex}
        className={`
              ${isOpen
                ? 'tw-border-t-2 tw-border-green'
                : isFirstInColumn
                    ? 'tw-border-t-0'
                    : 'tw-border-t tw-border-gray-300'
            }
            `}
      >
        <div
          className='tw-flex tw-justify-between tw-items-center tw-py-4 tw-px-2 md:tw-px-3 tw-cursor-pointer'
          onClick={() => toggleFaq(globalIndex)}
        >
          <h4 className={`tw-text-sm md:tw-text-base tw-font-medium tw-flex-grow ${isOpen ? 'tw-text-green' : 'tw-text-teal'}`}>
            {item.question}
          </h4>
          <div className='tw-ml-4 tw-flex-shrink-0'>
            {isOpen ? <MinusIcon /> : <PlusIcon />}
          </div>
        </div>
        {isOpen && (
          <div className='tw-px-2 md:tw-px-3 tw-pb-4'>
            <div className='tw-border-l-2 tw-border-green tw-pl-3 md:tw-pl-4'>
              <p className='tw-text-sm tw-text-slate-600'>
                {item.answer}
              </p>
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <section id='faq' className='tw-container xl:tw-max-w-7xl tw-mx-auto tw-px-4 tw-py-20 md:tw-py-28 xl:tw-py-32 tw-pb-0'>
      <div className='tw-text-center tw-mb-12 lg:tw-mb-16'>
        <h2 className='tw-text-sm tw-font-semibold tw-uppercase tw-text-green tw-mb-2'>Pomoc i wsparcie</h2>
        <h3 className='tw-text-3xl lg:tw-text-4xl tw-font-bold tw-text-teal tw-mb-4'>Najczęściej zadawane pytania</h3>
      </div>

      <div className='tw-flex tw-flex-wrap -tw-mx-2 md:-tw-mx-3'>
        <div className='tw-w-full lg:tw-w-1/2 tw-px-2 md:tw-px-3'>
          {firstHalf.map((item, index) => renderFaqItem(item, index, index === 0))}
        </div>
        <div className='tw-w-full lg:tw-w-1/2 tw-px-2 md:tw-px-3'>
          {secondHalf.map((item, index) => renderFaqItem(item, index + halfIndex, index === 0))}
        </div>
      </div>
    </section>
  )
}

export default FAQ
